var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.4847V1.66667",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.6187L17.2854 4.33334",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 4.33334L4.61867 5.6187",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01693 17.6667V16.4265C8.01693 14.6273 5.33331 13.5006 5.33331 10.4053C5.33331 7.79457 7.42057 5.66666 9.99998 5.66666C12.581 5.66666 14.6666 7.79457 14.6666 10.4053C14.6666 13.5006 12.0023 14.6273 12.0023 16.4265V17.6667",
    fill: "#718AF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01693 17.6667V16.4265C8.01693 14.6273 5.33331 13.5006 5.33331 10.4053C5.33331 7.79457 7.42057 5.66666 9.99998 5.66666C12.581 5.66666 14.6666 7.79457 14.6666 10.4053C14.6666 13.5006 12.0023 14.6273 12.0023 16.4265V17.6667H8.01693Z",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.6667H12V19.2135C12 19.831 11.4954 20.3333 10.8751 20.3333H9.12495C8.50462 20.3333 8 19.831 8 19.2135V17.6667Z",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLight);
export default __webpack_public_path__ + "static/media/ic_light.42c22ade38e9740435079753959c1658.svg";
export { ForwardRef as ReactComponent };